import {
  Card,
  CardContent,
  CardHeader,
  Table,
  TableBody,
  TableCell,
  tableCellClasses,
  TableContainer,
  TableFooter,
  TableHead,
  TablePagination,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { styled } from "@mui/material/styles";
import { useDispatch, useSelector } from "react-redux";
import {
  hideApiLoader,
  showApiLoader,
} from "../../../../redux/tool-webjam/actions";
import { getSubscriptionPaymentHistory } from "../../../paymentRequest";
import { FEATURE_CUSTOM_PAYMENT } from "../../../../constant";
import { setSubscriptionPaymentHistory } from "../payment-reducer/actions";
import { usePrevious } from "../../../Utils";
import { formatDate } from "../AbstractHelperComponent";
import { isMobileBrowserC } from "../../../../Utils";
import { ct } from "../../../../constant-Utils";
import { getTranslatedSubsName } from "..";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: "var(--theme-primary-color)",
    color: theme?.palette?.common?.white,
    fontSize: 16,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 16,
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

const SubscriptionTable = () => {
  const { subscriptionPaymentHistory } = useSelector(
    (state) => state[FEATURE_CUSTOM_PAYMENT]
  );
  console.log(subscriptionPaymentHistory);
  const { list: paymentHistory } = subscriptionPaymentHistory;
  const [isLoading, setIsLoading] = useState(false);
  const [totalRecord, setTotalRecord] = useState(0);
  const [recordPerPage, setRecordPerPage] = useState(10);
  const [page, setPage] = useState(0);
  const [pageNo, setPageNo] = useState({
    currentPage: 0,
    nextPage: 0,
    prevPage: 0,
  });

  const dispatch = useDispatch();

  const fetchData = (pagination = "") => {
    setIsLoading(true);
    dispatch(showApiLoader(5));
    getSubscriptionPaymentHistory(pagination)
      .then((res) => {
        if (res.status == 1) {
          const data = res.data.data;
          dispatch(
            setSubscriptionPaymentHistory({
              list: data.data,
              pagination: data.pagination,
            })
          );
          setTotalRecord(data.pagination.count);
          setRecordPerPage(data.pagination.page.perPage);
          setPageNo(data.pagination.page);
        } else {
          dispatch(
            setSubscriptionPaymentHistory({
              list: [],
              pagination: paginationObject,
            })
          );
          setTotalRecord(0);
          setRecordPerPage(10);
          setPageNo({
            currentPage: 0,
            nextPage: 0,
            prevPage: 0,
          });
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        dispatch(hideApiLoader(2));
        setIsLoading(false);
      });
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const { target } = event;
    setRecordPerPage(+target.value);
    setPage(0);
  };

  // Page change pagination
  const prevPage = usePrevious(page);
  useEffect(() => {
    let p = 0;
    if (prevPage != undefined && prevPage < page) {
      p = pageNo.nextPage;
    } else if (prevPage != undefined && prevPage > page) {
      p = pageNo.prevPage;
    }
    if (prevPage != undefined && p > 0) {
      console.log("page will loading ", p)
      fetchData("?page=" + p + "&limit=" + recordPerPage)
    }
  }, [page])

  const paymentStatusObj = {
    succeeded: { icon: <Tooltip title={ct("rta-trmc.dashboard.paymentHistory.tooltip.success")} arrow><i className="fa fa-check-circle theme-font-color" style={{ fontSize: '30px' }} aria-hidden="true"></i></Tooltip>, text: ct("rta-trmc.dashboard.paymentHistory.tooltip.success") },
    unpaid: { icon: <Tooltip title={ct("rta-trmc.dashboard.paymentHistory.tooltip.pending")} arrow><i className="fa fa-clock-o" style={{ fontSize: '30px' }} aria-hidden="true"></i></Tooltip>, text: ct("rta-trmc.dashboard.paymentHistory.tooltip.pending") },
    pending: { icon: <Tooltip title={ct("rta-trmc.dashboard.paymentHistory.tooltip.pending")} arrow><i className="fa fa-clock-o" style={{ fontSize: '30px' }} aria-hidden="true"></i></Tooltip>, text: ct("rta-trmc.dashboard.paymentHistory.tooltip.pending") },
    failed: { icon: <Tooltip title={ct("rta-trmc.dashboard.paymentHistory.tooltip.failed")} arrow><i className="fa fa-times-circle theme-font-color" style={{ fontSize: '30px', color: "var(--theme-error-color)" }} aria-hidden="true"></i></Tooltip>, text: ct("rta-trmc.dashboard.paymentHistory.tooltip.failed") },
    active: { icon: <Tooltip title={ct("rta-trmc.dashboard.paymentHistory.tooltip.success")} arrow><i className="fa fa-check-circle theme-font-color" style={{ fontSize: '30px' }} aria-hidden="true"></i></Tooltip>, text: ct("rta-trmc.dashboard.paymentHistory.tooltip.active") },
    canceled: { icon: <Tooltip title={ct("rta-trmc.dashboard.paymentHistory.tooltip.failed")} arrow><i className="fa fa-times-circle theme-font-color" style={{ fontSize: '30px', color: "var(--theme-error-color)" }} aria-hidden="true"></i></Tooltip>, text: ct("rta-trmc.dashboard.paymentHistory.tooltip.canceled") },
  }
  const paymentTypesObj = {
    'subscription': ct("rta-trmc.dashboard.paymentHistory.typography.subscription")
  }

  const getTransactionId = (obj) => {
    if (obj?.userSubscription?.status == "trialing") {
      return obj?._id || "-";
    }
    return obj?.payment_data?.transaction_id || `txn_${obj?._id}` || "-";
  }
  const isMobile = isMobileBrowserC();

  return (
    <div>
      {!isMobile && <TableContainer>
        <Table aria-label="customized table" stickyHeader>
          <TableHead>
            <TableRow>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.transactionId")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.plan")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.startDate")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.endDate")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.paymentType")}</StyledTableCell>
              <StyledTableCell>{ct("rta-trmc.dashboard.paymentHistory.typography.status")}</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!isLoading && !paymentHistory?.length && (
              <StyledTableRow className="w-100">
                <StyledTableCell
                  colSpan={6}
                  style={{ textAlign: "-webkit-center" }}
                >
                  {ct("Translate.typography.noRecordFound")}
                </StyledTableCell>
              </StyledTableRow>
            )}
            {paymentHistory.map((row, i) => (
              <TableRow key={i} hover>
                <StyledTableCell>{getTransactionId(row)}</StyledTableCell>
                <StyledTableCell>{getTranslatedSubsName(row.package?.name)}</StyledTableCell>
                <StyledTableCell>
                  {row?.userSubscription?.start_at
                    ? formatDate(row?.userSubscription?.start_at, "YYYY-MM-DD")
                    : "-"}
                </StyledTableCell>
                <StyledTableCell>
                  {row?.userSubscription?.end_at
                    ? formatDate(row?.userSubscription?.end_at, "YYYY-MM-DD")
                    : "-"}
                </StyledTableCell>
                <StyledTableCell style={{textTransform:"capitalize"}}>{row?.payment_data?.payment_medium || '-'}</StyledTableCell>
                <StyledTableCell>
                  {paymentStatusObj[row?.payment_data?.status]?.icon || paymentStatusObj["failed"].icon}
                </StyledTableCell>
              </TableRow>
            ))}
          </TableBody>
          <TableFooter>
            {paymentHistory?.length && !isMobile ? (
              <TableRow>
                <TablePagination
                  rowsPerPageOptions={[10]}
                  count={totalRecord}
                  rowsPerPage={recordPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                  sx={{
                    fontSize: 16,
                  }}
                  SelectProps={{
                    MenuProps: { classes: { paper: "invite-pagination" } },
                  }}
                  className="welcome-pagination"
                />
              </TableRow>
            ) : null}
          </TableFooter>
        </Table>
      </TableContainer>}
      {/* Mobile cards start here */}
      {isMobile && !isLoading && !paymentHistory?.length && (<div className="w-100 text-center" style={{ fontSize: '16px' }}>{ct("Translate.typography.noRecordFound")}</div>)}
      {isMobile && (paymentHistory || []).map((row, i) => {
        return (<Card className="mb-5 custom-card-wrapper" key={i}>
          <CardHeader className="headerCustomeOtherRoom"
            sx={{ paddingBottom: "0px" }}
          // title={<div className="t_id"><span className="NameTitle1"><b>{ct("rta-trmc.dashboard.paymentHistory.typography.tnxId")} :</b></span><span className="transaction_details">{getTransactionId(row) || "N/A"}</span></div>}
          />
          <CardContent sx={{ paddingTop: "0px" }}>
            <div className="t_id"><Typography className="NameTitle1"><b>{ct("rta-trmc.dashboard.paymentHistory.typography.tnxId")} :</b></Typography><Typography className="transaction_details">{getTransactionId(row) || "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.plan")} :</b></Typography><Typography className="ml-2">{row.package?.name || "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.startDate")} :</b></Typography><Typography className="ml-2">{row?.userSubscription?.start_at
              ? formatDate(row?.userSubscription?.start_at, "YYYY-MM-DD")
              : "-"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.endDate")} :</b></Typography><Typography className="ml-2">{row?.userSubscription?.end_at
              ? formatDate(row?.userSubscription?.end_at, "YYYY-MM-DD")
              : "N/A"}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.paymentType")} :</b></Typography><Typography className="ml-2"style={{textTransform:"capitalize"}}>{row?.payment_data?.payment_medium || 'N/A'}</Typography></div>
            <div className="d-flex"><Typography><b>{ct("rta-trmc.dashboard.paymentHistory.typography.status")} :</b></Typography><Typography className="ml-2">{paymentStatusObj[row?.payment_data?.status]?.text || paymentStatusObj["failed"].text}</Typography></div>
          </CardContent>
        </Card>)
      })}
      {/* Mobile cards end here */}
      {
        paymentHistory?.length && isMobile ? (
          <div className="mobile-pagination-wrapper"><TablePagination
            rowsPerPageOptions={[10]}
            count={totalRecord}
            rowsPerPage={recordPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{
              fontSize: 16,
            }}
            SelectProps={{
              MenuProps: { classes: { paper: "invite-pagination" } },
            }}
            className="welcome-pagination mobile-pagination"
          /></div>
        ) : null
      }
    </div>
  );
};

export default SubscriptionTable;
